import {cn} from '../../../../../lib/classname';

type Props = {
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  children: React.ReactNode;
  loadingText?: string;
  className?: string;
};

export const ModalDeleteButton: React.FC<Props> = ({
  onClick,
  disabled = false,
  isLoading = false,
  children,
  loadingText = '削除中...',
  className,
}) => {
  const isDisabled = disabled || isLoading;

  return (
    <button
      type="button"
      className={cn(
        'min-w-[128px] text-base font-bold rounded-full px-16 py-[10px] border-[2px]',
        {
          'border-background-2 bg-background-2 text-black-3 cursor-not-allowed':
            isDisabled,
          'border-error bg-error text-white': !isDisabled,
        },
        className,
      )}
      onClick={onClick}
      disabled={isDisabled}
    >
      {isLoading ? loadingText : children}
    </button>
  );
};
